export default __webpack_public_path__ + "assets/e0a5efe78426861d7f78624e5538a8eb.png";